import React from "react";
import "../services/services.scss";
import Rectangle from "../../../assets/images/icons/Rectangle 529.jpg";
import Group from "../../../assets/images/icons/Group 8870.svg";
import Group1 from "../../../assets/images/icons/Group.svg";
import Group2 from "../../../assets/images/icons/Group (1).svg";
import Group3 from "../../../assets/images/icons/Group (2).svg";
import Group4 from "../../../assets/images/icons/Group (3).svg";
import { Fade } from "react-reveal";
export default function Service() {
  const Service_card = [
    {
      image: Rectangle,
      icon: Group,
      heading: "Mobile Application Development",
      description:
        "Our Web and Mobile Development services offer comprehensive solutions tailored to meet the dynamic digital needs of businesses. With a keen focus on cutting-edge technologies and user-centric design, our team crafts seamless and responsive applications that drive engagement and enhance user experiences across various platforms.",
    },
    {
      image: Rectangle,
      icon: Group1,
      heading: "Backend Development",
      description:
        "Unlock the engine behind seamless user experiences with our expert backend development services. From robust APIs to scalable architectures, we ensure your digital infrastructure is primed for efficiency, reliability, and future growth. Trust us to power your digital ambitions.",
    },
    {
      image: Rectangle,
      icon: Group2,
      heading: "Frontend Development",
      description:
        "Elevate your digital presence with our frontend development expertise. From captivating designs to intuitive user interfaces, we craft immersive web and mobile experiences. Let us transform your vision into stunning realities that engage and inspire your audience.",
    },
    {
      image: Rectangle,
      icon: Group3,
      heading: "Blockchain",
      description:
        "Revolutionize your digital infrastructure with our blockchain solutions. From decentralized applications to secure transactions, we leverage the power of blockchain technology to enhance transparency, security, and efficiency in your business processes. Explore the future of trust and innovation with us.",
    },
    {
      image: Rectangle,
      icon: Group4,
      heading: "UI / UX Design",
      description:
        "Transform user experiences with our UI/UX design services. We craft intuitive interfaces and engaging designs tailored to your audience, ensuring seamless interaction and enhancing user satisfaction. Let us elevate your digital presence with captivating design solutions that leave a lasting impression.",
    },
    {
      image: Rectangle,
      icon: Group1,
      heading: "AI / ML App Services",
      description:
        "Unlock the potential of AI/ML with our cutting-edge app services. From predictive analytics to personalized recommendations, we integrate advanced algorithms to empower your applications. Experience enhanced efficiency, accuracy, and innovation as we revolutionize your digital solutions with AI/ML capabilities.",
    },
  ];
  return (
    <section className="service_section">
      <div className="container">
        <div className="service-heading">
          <Fade bottom duration={600} delay={400}>
            <h2 className="heading" title="Services">SERVICES</h2>
          </Fade>
          <Fade bottom duration={700} delay={500}>
            <p title="Discover our diverse range of services catering to digital
              transformation, innovation, and enhanced user experiences,
              tailored to meet your business needs and objectives.">
              Discover our diverse range of services catering to digital
              transformation, innovation, and enhanced user experiences,
              tailored to meet your business needs and objectives.
            </p>
          </Fade>
        </div>
        <div className="main-grid">
          {Service_card &&
            Service_card?.map((el, i) => {
              return (
                <Fade bottom duration={900} delay={800}>
                  <div className="sub-grid" key={i} title={el?.heading}>
                    <div className="position">
                      <img src={el?.image} alt="Service" />
                      <div className="group-image">
                        <img src={el?.icon} alt="Technology" />
                      </div>
                    </div>
                    <div className="card-heading">
                      <h2>{el?.heading}</h2>
                      <p>{el?.description}</p>
                    </div>
                  </div>
                </Fade>
              );
            })}
        </div>
      </div>
    </section>
  );
}
